import { FC, useEffect, useState } from "react";

import { RatioItemDisplay } from "./ratio-item.display";
import { RatioItemEdit } from "./ratio-item.edit";
import { IRatioItemFormProps } from "./table-ratios.models";

export const RatioItem: FC<IRatioItemFormProps> = ({
  fieldName,
  index,
  value,
  control,
  setValue,
  getValues,
  removeHandler,
  onEditStart,
  onEditEnd,
}) => {
  const [inEdit, setInEdit] = useState(false);

  useEffect(() => {
    if (inEdit) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [inEdit, onEditStart, onEditEnd]);

  return (
    <>
      {!inEdit && (
        <RatioItemDisplay
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          control={control}
          removeHandler={removeHandler}
          index={index}
          value={value}
          onEdit={() => {
            setInEdit(true);
          }}
        />
      )}

      {inEdit && (
        <RatioItemEdit
          fieldName={fieldName}
          setValue={setValue}
          getValues={getValues}
          index={index}
          value={value}
          onCancel={() => {
            setInEdit(false);
          }}
        />
      )}
    </>
  );
};
